export default "__VITE_ASSET__DoS8KNai__"